import React from 'react';
import { Tabs } from 'web-library';
import { TFunction } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {typeTheme} from "web-library/theme/helper/tssHelper"

import { makeStyles } from 'tss-react/mui';

interface ICandidateSubjectListTabPanel {
  tabStateHandler: {
    selectedTab: number;
    setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  };
  t: TFunction<'translation'>;
}

const tabRadius = '10px';
const setOrUnsetRadius = (selectedTabProp: number, selectedTab: number) =>
  selectedTabProp === selectedTab ? 'unset' : tabRadius;

// @ts-ignore
const useStyles = makeStyles<{selectedTab: number}>()((theme, {selectedTab}) =>
({
  root: {
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    boxShadow: theme.shadow.shadow1,
    borderRadius: tabRadius,
    marginBottom: theme.spacing(4),
    '& .MuiButtonBase-root.MuiTab-root': {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      ...typeTheme(theme, 'buttonLarge'),
      padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
      '&:first-child': {
        borderTopLeftRadius: tabRadius,
        borderBottomLeftRadius: tabRadius,
      },
      '&:last-child': {
        borderTopRightRadius: tabRadius,
        borderBottomRightRadius: tabRadius,
      },
      '&.MuiTab-textColorPrimary.Mui-selected': {
        color: theme.color.text.textContrast,
        zIndex: 1,
      },
    },
    '& .MuiTabs-indicator': {
      borderRadius: '50px',
      borderTopRightRadius: setOrUnsetRadius(selectedTab, 0),
      borderBottomRightRadius: setOrUnsetRadius(selectedTab, 0),
      borderTopLeftRadius: setOrUnsetRadius(selectedTab, 1),
      borderBottomLeftRadius: setOrUnsetRadius(selectedTab, 1),
      backgroundColor: theme.color.link.linkActive01,
      height: '100%',
    },
  },
}));
const CandidateSubjectListTabPanels = ({ tabStateHandler, t }: ICandidateSubjectListTabPanel) => {
  const { selectedTab, setSelectedTab } = tabStateHandler;
  const { classes } = useStyles({ selectedTab });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const onChangeTab = (event: any, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Tabs
      className={classes.root}
      value={selectedTab}
      tabs={[
        t('exam->>ReviewExam.CandidateList').toString(),
        t('exam->>ReviewExam.SubjectOverview').toString(),
      ]}
      onChange={onChangeTab}
      variant={isMobile ? 'scrollable' : 'standard'}
      scrollButtons={isMobile}
      aria-label="Application Status tabs"
    />
  );
};

export default CandidateSubjectListTabPanels;
